import styled from 'styled-components'

export const Logo = styled.div`
    width: 220px;
    height: 64px;
`